import { Component, HostListener } from '@angular/core';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { User } from '../../../shared/models/auth';

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.component.html'
})
export class HeaderComponent {
  isFixed: boolean = false;
  language = localStorage.getItem('language') || 'ar';
  currentUser: User | null = new User();

  isSuperAdmin = false;
  menuOpened = false;

  constructor(
    private authService: AuthenticationService
  ) {
    this.currentUser = this.authService.currentUserValue;
    this.isSuperAdmin = this.currentUser?.type == 'admin';
  }

  changeLanguage() {
    let lang = this.language == 'en' ? 'ar' : 'en'
    localStorage.setItem('language', lang);
    window.location.reload();
  }

  logout() {
    this.authService.logout();
  }

  @HostListener('window:scroll', []) onWindowScroll() {
    this.isFixed = window.scrollY > 100;
  }
}
